<script>
import adminTable from './mixins/adminTable'
import axios from 'axios'
export default
{
    mixins: [ adminTable ],

    methods:
    {

        fetch()
        {
            axios.get(process.env.API_URL + this.url, { params: { type: this.selectedType }}).then(res => {
                this.data = res.data || []
                this.updateData()
            }).catch(e => {})
        },

        fetchTypes()
        {
            axios.get(`${process.env.API_URL}/v1/admin/formtypes`).then(res => {
                this.types = res.data
                if (this.types.length > 0)
                {
                    this.selectedType = this.types[0]
                    this.fetch()
                }
            })
        },

        applyTypeFilter(val)
        {
            this.selectedType = val
            this.fetch()
        }
    },

    data()
    {
        return {
            data: [],
            types: [],
            selectedType: null,
            url: '/v1/admin/forms',
            tableName: 'tableForms',
            emptyModel: {},
            columns: [ 'id', 'email', 'created_at', 'actions'],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                },
                perPage: 50,
                perPageValues: [10, 25, 50, 100, 200, 400],
                saveState: true,
                highlightMatches: true,
                filterByColumn: true,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['email'],
            }
        }
    },

    mounted()
    {
        this.fetchTypes()
    }


}
</script>

<template>
    <div class="container-fluid">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label text-left">
                {{ $t('FORMS.TYPE') }}
            </label>
            <div class="col-md-8">
                <v-select :options="types" label="name" :value="selectedType" @input="applyTypeFilter">

                </v-select>
            </div>
        </div>

        <mv-modal ref="form">
            <span slot="header">{{ $t('MENU.FORMS') }}</span>
            <div class="row" v-if="model && model.data" v-for="(val, key) in model.data" :key="key">
                <div class="col-sm-4 col-sm-offset-2">
                    <strong>
                        {{ key }}
                    </strong>
                </div>
                <div class="col-sm-6">
                    <template v-if="val instanceof Array">
                        <template v-for="item in val">
                            <template v-if="item instanceof Object && item.title">
                                {{ item.title }},
                            </template>
                            <template v-else> {{ item }}, </template>
                        </template>
                    </template>
                    <template v-else>
                        {{ val }}
                    </template>
                </div>
            </div>
        </mv-modal>

        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.FORMS') }}</h4>
                    </div>

                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-success" @click="exportFile">
                            <icon name="download"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="search"></icon>
                        </button>
                    </div>
                    <div slot="email" slot-scope="props">
                        <template v-if="props.row.email">
                            {{ props.row.email }}
                        </template>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Forms.vue